<template>
  <div>
    <h3 class="tw-pt-4 tw-text-2xl tw-text-center">
      Welcome Back!
    </h3>
    <b-form
      class="tw-px-8 tw-pt-6 tw-pb-8 tw-mb-4 tw-bg-white tw-rounded"
      @submit.prevent="login"
    >
      <div class="tw-mb-4">
        <label
          class="tw-block tw-mb-2 tw-text-sm tw-font-bold tw-text-gray-700"
          for="username"
        >
          Email
        </label>
        <input
          v-model="email"
          class="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-leading-tight tw-text-gray-700 tw-border tw-rounded tw-shadow tw-appearance-none focus:tw-outline-none focus:tw-shadow-outline"
          autocomplete="email"
          type="text"
          placeholder="Your email"
          required
        >
      </div>
      <div class="tw-mb-4">
        <label
          class="tw-block tw-mb-2 tw-text-sm tw-font-bold tw-text-gray-700"
          for="password"
        >
          Password
        </label>
        <input
          v-model="password"
          class="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-leading-tight tw-text-gray-700 tw-border tw-rounded tw-shadow tw-appearance-none focus:tw-outline-none focus:tw-shadow-outline"
          autocomplete="current-password"
          type="password"
          placeholder="Your password"
          required
        >
      </div>
      <div class="tw-mb-4">
        <input
          id="checkbox_id"
          class="tw-mr-2 tw-leading-tight"
          type="checkbox"
        >
        <label
          class="tw-text-sm"
          for="checkbox_id"
        >
          Remember Me
        </label>
      </div>
      <div class="tw-mb-6 tw-text-center">
        <button
          class="tw-w-full tw-px-4 tw-py-2 tw-font-bold tw-text-white tw-bg-blue-500 tw-rounded-full hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-shadow-outline"
          type="submit"
        >
          Sign In
        </button>
      </div>
      <hr class="tw-mb-6 tw-border-t">
      <div class="tw-text-center">
        <router-link
          class="tw-inline-block tw-text-sm tw-text-blue-500 tw-align-baseline hover:tw-text-blue-800"
          to="/register"
        >
          Create an Account!
        </router-link>
      </div>
      <div class="tw-text-center">
        <router-link
          class="tw-inline-block tw-text-sm tw-text-blue-500 tw-align-baseline hover:tw-text-blue-800"
          to="/forgotten-password"
        >
          Forgot Password?
        </router-link>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      password: null,
      error: false,
    };
  },

  mounted() {
    if (this.$is_dev && !window.Cypress) {
      const index = this.$route.query.id || 0;
      const usernames = JSON.parse(process.env.VUE_APP_DEV_USERNAME);
      const passwords = JSON.parse(process.env.VUE_APP_DEV_PASSWORD);
      this.email = usernames[index];
      this.password = passwords[index];
      // console.log(usernames, this.email);
      // console.log(passwords, this.password);
    }

    console.log(`logged in: ${this.$auth.check()}`);

    if (this.$auth.check()) {
      this.$router.push('/');
    }
  },

  methods: {
    login() {
      // const redirect = this.$auth.redirect();

      const app = this;

      Bus.$emit('loading', true);

      this.$auth.login({
        data: {
          email: app.email,
          password: app.password,
        },
        success() {
          console.log('login -> success');
          Bus.$emit('modals:hide-all');
          Bus.$emit('loading', true);
          this.$nextTick(() => {
            setTimeout(() => {
              Bus.$emit('loading', false);
              this.$router.push('/');
            }, 750);
          });

          // this.loadWelcomeMessage();
        },
        error(err) {
          console.log('login -> error');
          console.log('err', err.response);
          Bus.$emit('loading', false);

          Bus.$emit('ok-box:show', {
            title: 'Error',
            // body: err.response.data.errors[0],
            body: err.response.data.msg,
            okVariant: 'danger',
          });
        },
        rememberMe: true,
        fetchUser: true,
        redirect: false,
      });
    },
  },
};
</script>
